<svg
  *ngIf="isFlat === false"
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="6 7 12 10"
  width="24px"
>
  <path
    d="M18,17h-6v-2h6v2z M15,13H9v-2h6V13z M12,9H6v-2h6v2z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="isFlat === true"
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="6 7 12 10"
  width="24px"
>
  <path
    d="M15,9H9v-2h6v2z M15,13H9v-2h6v2z M15,17H9v-2h6v2z"
    fill="currentColor"
  />
</svg>
